import React from 'react';
import { Text } from '@chakra-ui/react';
import SdgIndicator from './SdgIndicator';
import contentJson from '../utils/content.json';

const content: any = contentJson;

type SdgItemWithIndicatorsProps = {
  sdgNumber: number;
};

export const SdgItemWithIndicators = ({
  sdgNumber,
}: SdgItemWithIndicatorsProps) => {
  const currentContent = content[`sdg${sdgNumber}`];
  return (
    <>
      <SdgIndicator
        label="Numerical indicators"
        value={currentContent.numericalIndicator}
        color={currentContent.color}
      />
      <SdgIndicator
        label="Evidence indicators"
        value={currentContent.evidenceIndicator}
        color={currentContent.color}
      />
      <SdgIndicator
        label="Policy questions"
        value={currentContent.policyQuestion}
        color={currentContent.color}
      />

      <Text fontWeight="bold" mb={4}>
        Ranking size
      </Text>

      <SdgIndicator
        label="Number of universities ranked (2025)"
        value={`${currentContent.numberOfUniversitiesRanked} (out of 2526)`}
        color={currentContent.color}
      />
    </>
  );
};
